// import "./vendor/plugins.js"

import { App } from './src/App.js';

// Get App instance
window.app = new App();